import { useState, useEffect } from 'react';
import axios from 'axios';
import './ManageCategories.css';

export default function ManageCategories() {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [editCategoryName, setEditCategoryName] = useState('');

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const categoriesPerPage = 5;

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get('https://spinelleapi.emedha.in/admin/product/api/categories');
      setCategories(res.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const addCategory = async () => {
    if (newCategory.trim() === '') return;
    try {
      await axios.post('https://spinelleapi.emedha.in/admin/product/api/categories', { name: newCategory });
      setNewCategory('');
      fetchCategories();
    } catch (error) {
      console.error('Error adding category:', error);
    }
  };

  const deleteCategory = async (id) => {
    try {
      await axios.delete(`https://spinelleapi.emedha.in/admin/product/api/categories/${id}`);
      fetchCategories();
    } catch (error) {
      console.error('Error deleting category:', error);
    }
  };

  const startEditing = (id, name) => {
    setEditCategoryId(id);
    setEditCategoryName(name);
  };

  const cancelEditing = () => {
    setEditCategoryId(null);
    setEditCategoryName('');
  };

  const updateCategory = async (id) => {
    try {
      await axios.put(`https://spinelleapi.emedha.in/admin/product/api/categories/${id}`, { name: editCategoryName });
      setEditCategoryId(null);
      setEditCategoryName('');
      fetchCategories();
    } catch (error) {
      console.error('Error updating category:', error);
    }
  };

  // Pagination Calculations
  const indexOfLastCategory = currentPage * categoriesPerPage;
  const indexOfFirstCategory = indexOfLastCategory - categoriesPerPage;
  const currentCategories = categories.slice(indexOfFirstCategory, indexOfLastCategory);
  const totalPages = Math.ceil(categories.length / categoriesPerPage);

  const changePage = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="manage-container">
      <h2>Manage Categories</h2>
      <div className="form-group">
        <input
          type="text"
          placeholder="Category Name"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
        />
        <button onClick={addCategory}>Add Category</button>
      </div>

      <table className="category-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Category Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentCategories.map((cat, index) => (
            <tr key={cat.id}>
              <td>{indexOfFirstCategory + index + 1}</td>
              <td>
                {editCategoryId === cat.id ? (
                  <input
                    type="text"
                    value={editCategoryName}
                    onChange={(e) => setEditCategoryName(e.target.value)}
                  />
                ) : (
                  cat.name
                )}
              </td>
              <td>
                {editCategoryId === cat.id ? (
                  <>
                    <button className="update-btn" onClick={() => updateCategory(cat.id)}>Update</button>
                    <button className="cancel-btn" onClick={cancelEditing}>Cancel</button>
                  </>
                ) : (
                  <>
                    <button className="edit-btn" onClick={() => startEditing(cat.id, cat.name)}>Edit</button>
                    <button className="delete-btn" onClick={() => deleteCategory(cat.id)}>Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => changePage(i + 1)}
            className={currentPage === i + 1 ? 'active' : ''}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
}
